<ps-ui-modal class="supplier-allocation-modal">
  <ps-ui-modal-body class="supplier-allocation-modal-body">
    <ps-ui-edit-suppliers
      [surveyId]="surveyCreationObject?.surveyId"
    ></ps-ui-edit-suppliers>
  </ps-ui-modal-body>
</ps-ui-modal>
